import { render, staticRenderFns } from "./PlatformSection.vue?vue&type=template&id=04f4117c&scoped=true&"
import script from "./PlatformSection.vue?vue&type=script&lang=js&"
export * from "./PlatformSection.vue?vue&type=script&lang=js&"
import style0 from "./PlatformSection.vue?vue&type=style&index=0&id=04f4117c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f4117c",
  null
  
)

export default component.exports